export default function parseDate(date) {
  let parsedDate = new Date(date);
  if (date === 'now') {
    return null;
  }

  if (!(parsedDate instanceof Date && !isNaN(parsedDate))) {
    parsedDate = new Date(parseInt(date));
  }
  return parsedDate;
}
